import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {AuditTrailPage} from '../models/auditTrailPage';
import {AuditTrailFilterCriteria} from '../models/filter/audit-trail-filter-criteria';

@Injectable()
export class AuditTrailService {

  constructor(private httpClient: HttpClient) {
  }

  getAuditTrail(auditTrailFilterCriteria: AuditTrailFilterCriteria, page: number, pageSize: number): Observable<AuditTrailPage> {
    let params = new HttpParams().set('page', page).set('pageSize', pageSize);
    if (auditTrailFilterCriteria.action) {
      params = params.set('action', auditTrailFilterCriteria.action);
    }
    if (auditTrailFilterCriteria.companyUniqid) {
      params = params.set('companyUniqid', auditTrailFilterCriteria.companyUniqid);
    }
    if (auditTrailFilterCriteria.dateFrom) {
      params = params.set('dateFrom', auditTrailFilterCriteria.dateFrom);
    }
    if (auditTrailFilterCriteria.dateTo) {
      params = params.set('dateTo', auditTrailFilterCriteria.dateTo);
    }

    return this.httpClient.get<AuditTrailPage>(environment.baseUrlWs + '/api/client/audit-trail', {params});
  }

  getAuditTrailOfUser(userUniqid: string, page: number, pageSize: number): Observable<AuditTrailPage> {
    const params = new HttpParams().set('page', page).set('pageSize', pageSize);

    return this.httpClient.get<AuditTrailPage>(
      environment.baseUrlWs + '/api/client/users/' + userUniqid + '/audit-trail', {params}
    );
  }
}
